export default function ComeSiUsa() {
  return (
    <main data-testid="come-si-usa-page" className="container-essenya py-16 max-w-3xl">
      <div className="text-eyebrow mb-3">Guida</div>
      <h1 className="font-display text-4xl md:text-5xl mb-3">Come usare i prodotti ESSENYA</h1>
      <p className="text-essenya-text text-lg mb-12">Pochi gesti, una casa più pulita e profumata.</p>
      <div className="space-y-12">
        <Block n="01" title="Lavapavimenti" items={[
          'Diluire un tappo del prodotto in 5L di acqua tiepida.',
          'Usare su tutti i pavimenti lavabili.',
          'Non eccedere con le quantità: poco prodotto basta.',
          'Testare prima su superfici delicate.',
          'Richiudere bene il flacone dopo l\'uso.',
        ]} />
        <Block n="02" title="Sgrassatore" items={[
          'Spruzzare direttamente sulla superficie.',
          'Lasciare agire qualche secondo.',
          'Passare con panno umido o microfibra.',
          'Risciacquare se necessario (per cibo).',
          'Evitare superfici delicate non compatibili.',
        ]} />
        <Block n="03" title="Consigli per far durare di più il profumo" items={[
          'Pulire con porte e finestre chiuse.',
          'Aerare solo dopo qualche minuto.',
          'Usare il prodotto su superfici asciutte ben pulite.',
        ]} />
        <Block n="04" title="Dove usare i prodotti" items={[
          'Ingresso, soggiorno, cucina, bagno, camera da letto.',
          'Pavimenti lavabili, piastrelle, marmo, parquet trattato.',
          'Superfici lavabili: top cucina, fornelli, mobili.',
        ]} />
      </div>
    </main>
  );
}
const Block = ({ n, title, items }) => (
  <div className="border-t border-essenya-ink pt-6">
    <p className="text-eyebrow">{n}</p>
    <h2 className="font-display text-2xl md:text-3xl mt-2 mb-5">{title}</h2>
    <ul className="space-y-2">{items.map((i, idx) => <li key={idx} className="text-essenya-text flex gap-3"><span className="text-essenya-ink">·</span>{i}</li>)}</ul>
  </div>
);
